import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-clm-cooling-performance-input',
    imports: [
    MatIcon,
    ReactiveFormsModule,
    FormsModule
],
    templateUrl: './clm-cooling-performance-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-cooling-performance-input.component.css'
})
export class ClmCoolingPerformanceInputComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  airflowSelection!: GuruEntity;
  edbSelection!: GuruEntity;
  ewbSelection!: GuruEntity;
  eftSelection!: GuruEntity;
  performanceMethodSelection!: GuruEntity;
  totalCapacitySelection!: GuruEntity;
  sensibleCapacitySelection!: GuruEntity;
  ldbSelection!: GuruEntity;
  fluidFlowSelection!: GuruEntity;
  loadEftSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.COOLING_PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.airflowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCFAirflow');
    this.edbSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCEDB');
    this.ewbSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCEWB');
    this.eftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCEWT');
    this.performanceMethodSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCWI');
    this.totalCapacitySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCWTot');
    this.sensibleCapacitySelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCWSens');
    this.ldbSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCLDB');
    this.fluidFlowSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCWFR');
    this.loadEftSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCLEWT');
  }

  textSelectionChanged(entity: GuruEntity): void {
    this.selectionChanged(entity, entity.Value);
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

  isMethodSelected(methodName: string): boolean {
    return (this.performanceMethodSelection?.Value || '') === methodName;
  }

}
